import React, { useCallback, useMemo, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import {
    GoogleMap,
    Marker,
    Data,
    LoadScript,
    LoadScriptNext
} from "@react-google-maps/api";
import { NEXT_PUBLIC_GOOGLE_MAPS_API_KEY } from '../../../helpers/urlBase';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: "#ffffff",
        color: "#000000",
        fontFamily: 'HelveticaNeueLT Std Cn'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

let posicion = { 'lat': 0, 'lng': 0 };
let direccion_seleccionada = '';


export const MapControl = ( { open, handleClose, handleGuardar, latitud_ie, longitud_ie, latitud_user, longitud_user, coordenadas, id = 0 } ) => {
    const classes = useStyles();
    const google = window.google;

    // const coord_ie = useMemo( () => ( { lat: parseFloat(latitud_ie), lng: parseFloat(longitud_ie) } ), [] );
    const coord_ie = { lat: parseFloat(latitud_ie), lng: parseFloat(longitud_ie) };
    const coord_user = { lat: parseFloat(latitud_user), lng: parseFloat(longitud_user) };
    let center = { lat: parseFloat(latitud_ie), lng: parseFloat(longitud_ie) };
    
    
    // const options = useMemo( () => ( {
    //     mapId: "2684c20afdb728e7",
    //     isMarkerShown: true,
    //     // disableDefaultUI: false,
    //     // clickableIcons: false
    // } ), [] );
    const options = {
        mapId: "2684c20afdb728e7",
        isMarkerShown: true,
        // disableDefaultUI: false,
        // clickableIcons: false
    };

    if (coordenadas.lat != 0)
    {
        center = coordenadas;
    }
    else if (latitud_user != null && latitud_user != 0)
    {
        center.lat = latitud_user;
        center.lng = longitud_user;
    }
    
    const [map, setMap] = useState(null);
    const onMapLoad = useCallback((map) => {
        setMap(map)
    }, [])


    const dataOptions = useMemo(() => {
        return map !== null
        ? 
            {
                map,
                controlPosition: google.maps.ControlPosition.TOP_LEFT,
                controls: ['Point'],
                drawingMode: 'Point', //  "LineString" or "Polygon".
                featureFactory: (geometry) => {
                    const latitud = geometry.g.lat();
                    const longitud = geometry.g.lng();
                    posicion = { 'lat': latitud, 'lng': longitud }



                    fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitud}&lon=${longitud}`)
                    .then(async response => {
                        const isJson = response.headers.get('content-type')?.includes('application/json');
                        const data = isJson && await response.json();
                
                        if (!response.ok) {
                            const error = (data && data.message) || response.status;
                            return Promise.reject(error);
                        }

                        console.log(data.display_name);
                        direccion_seleccionada = data.display_name;

                            
                    })
                    .catch(error => {
                        console.log("Error de buscar dirección por coordenadas: " + error)
                    });


                    // new google.maps.Geocoder().geocode({ location: posicion }).then((response) => {
                    //     let direccion = '';
                    //     response.results.forEach(x => {
                    //         if (x.types.includes('street_address'))
                    //             direccion = x.formatted_address;
                    //     });
                    //     if (direccion == '')
                    //         response.results.forEach(x => {
                    //             if (x.types.includes('political') && x.types.includes('sublocality') && x.types.includes('sublocality_level_1'))
                    //                 direccion = x.formatted_address;
                    //         });
                    //     if (direccion == '')
                    //         response.results.forEach(x => {
                    //             if (x.types.includes('political') && x.types.includes('sublocality') && x.types.includes('sublocality_level_2'))
                    //                 direccion = x.formatted_address;
                    //         });

                    //     let region = '';
                    //     let provincia = '';
                    //     let distrito = '';
                    //     response.results.forEach(x => {
                    //         if ( x.types.includes('administrative_area_level_1') && x.types.includes('political') )
                    //             region = x.formatted_address.split(",")[0];
                    //         if ( x.types.includes('administrative_area_level_2') && x.types.includes('political') )
                    //             provincia = x.formatted_address.split(",")[0];
                    //         if ( x.types.includes('administrative_area_level_3') && x.types.includes('political') )
                    //             distrito = x.formatted_address.split(",")[0];
                    //     });

                    //     let locality = '';
                    //     if (direccion == '') {
                    //         response.results.forEach(x => {
                    //             if (x.types.includes('route'))
                    //                 direccion = x.formatted_address;
                    //             if (x.types.includes('political') && x.types.includes('locality') && x.types.length == 2)
                    //                 locality = x.formatted_address;
                    //         });
                            
                    //         if (direccion == '')
                    //         {
                    //             response.results.forEach(x => {
                    //                 if (x.types.includes('postal_code'))
                    //                     direccion = x.formatted_address;
                    //             });
                    //             direccion += ( locality != '' ? ' (' + locality + ')' : (' | ' + region + '-' + provincia + '-' + distrito) );
                    //         }
                    //         else {
                    //             direccion += (locality != '' ? ' (' + locality + ')' : (' | ' + region + '-' + provincia + '-' + distrito) );
                    //         }

                    //     }
                    //     else {
                    //         direccion += ' | ' + region + '-' + provincia + '-' + distrito;
                    //     }

                    //     console.log(direccion);
                    //     direccion_seleccionada = direccion;

                    // }).catch((e) => console.log("Error de buscar dirección por coordenadas: " + e));


                    return new google.maps.Data.Feature({
                        id: '1',
                        geometry
                        })

                }
            }
        : 
            null
    }, [map])


    const onClick = (...args) => {
        console.log( 'onClick args: ', args[0].latLng.lat(), ' : ', args[0].latLng.lng() )
    }

    const onDataLoad = (data) => {
        console.log('data: ', data)
    }

    return (
        <>
            <Dialog fullScreen open={ open } onClose={ handleClose } TransitionComponent={ Transition }>
                <AppBar className={ classes.appBar }>
                    <Toolbar>
                        <IconButton edge="start" color="secondary"
                        onClick={ handleClose } aria-label="close">
                        <CloseIcon />
                        </IconButton>
                        <Typography variant="h7" className={ classes.title }>
                            Seleccione la ubicación
                        </Typography>
                        {/* <Typography variant="h7" className={ classes.title }>
                            {direccion_seleccionada}
                        </Typography> */}
                        <Button variant="contained" autoFocus onClick={ ( e ) => handleGuardar( e, posicion, direccion_seleccionada, id ) }
                        color="primary" size="large"
                        >
                            Aceptar
                        </Button>
                    </Toolbar>
                </AppBar>
                
                <div className='container'>
                    <div className='map'>
                    {/* <MapView></MapView> */}
                        <LoadScriptNext googleMapsApiKey={ NEXT_PUBLIC_GOOGLE_MAPS_API_KEY }>
                            <GoogleMap
                            zoom={ 15 }
                            center={ center }
                            mapContainerClassName="map-container"
                            options={ options }
                            onClick={ onClick }
                            onLoad={ onMapLoad }
                            // mapTypeId={ google.maps.MapTypeId.SATELLITE }
                            >
                                {
                                    (latitud_user != null && latitud_user != 0)
                                    &&
                                    <Marker
                                    key={'userMarker'}
                                    position={ coord_user }
                                    icon={ {
                                        url: './assets/images/user.png',
                                        scaledSize: { width: 50, height: 50 },
                                    } }
                                    />
                                }
                                <Marker
                                    position={ coord_ie }
                                    icon={ {
                                        url: './assets/images/school.png',
                                        scaledSize: { width: 50, height: 50 },
                                    } }
                                />
                                {
                                    coordenadas.lat != 0 &&
                                    <Marker
                                        position={ coordenadas }
                                        icon={ {
                                            url: './assets/images/marker.png',
                                            scaledSize: { width: 50, height: 50 },
                                        } }
                                    />
                                }
                                {
                                    dataOptions !== null &&
                                    <Data onLoad={onDataLoad} options={dataOptions} />
                                }
                            </GoogleMap>
                        </LoadScriptNext>
                    </div>
                </div>
            </Dialog>
        </>
    );
}


{/* <Marker
    position={ coord_ie }
    icon={{
        path: "M8 12l-4.7023 2.4721.898-5.236L.3916 5.5279l5.2574-.764L8 0l2.3511 4.764 5.2574.7639-3.8043 3.7082.898 5.236z",
        fillColor: "yellow",
        fillOpacity: 0.9,
        scale: 2,
        strokeColor: "gold",
        strokeWeight: 2,
    }}
/> */}


    // if (navigator.geolocation) 
    // {
    //     navigator.geolocation.watchPosition((position) => {
    //         debugger;
    //         setUserPosition({
    //             latitude: position.coords.latitude,
    //             longitude: position.coords.longitude,
    //         });
    //     });
    // }


